/* ============================================================
   ZenVoraFit PDP — Sticky Add to Cart (mobile)
   ============================================================ */
(function () {
  'use strict';

  function initStickyAtc() {
    var atcWrap  = document.querySelector('.shopify-payment-button, [data-type="add-to-cart"], buy-buttons, .product-form__buttons');
    var stickyBar = document.querySelector('.pdp-sticky-atc');
    var stickyBtn = document.querySelector('.pdp-sticky-atc__btn');

    if (!atcWrap || !stickyBar) return;

    var observer = new IntersectionObserver(
      function (entries) {
        var entry = entries[0];
        if (!entry.isIntersecting) {
          stickyBar.classList.add('is-visible');
          stickyBar.setAttribute('aria-hidden', 'false');
        } else {
          stickyBar.classList.remove('is-visible');
          stickyBar.setAttribute('aria-hidden', 'true');
        }
      },
      { rootMargin: '0px 0px -60px 0px', threshold: 0 }
    );

    observer.observe(atcWrap);

    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var nativeAtc = document.querySelector('[name="add"], .product-form__submit, button[data-add-to-cart]');
        if (nativeAtc) {
          nativeAtc.click();
        } else {
          var form = document.querySelector('form[action="/cart/add"]');
          if (form) form.submit();
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyAtc);
  } else {
    initStickyAtc();
  }
})();
